import { render, staticRenderFns } from "./GuppyDeleteMessage.vue?vue&type=template&id=7806b5d0&"
import script from "./GuppyDeleteMessage.vue?vue&type=script&lang=js&"
export * from "./GuppyDeleteMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports